module.exports = __webpack_public_path__ + "static/media/logo-prize.0daa9a40.png";